import React from 'react';
import Button from './Button';

import operate from '../Assets/operate.svg'
import eject from '../Assets/eject.svg'
import stop from '../Assets/stop.svg'
import play from '../Assets/play.svg'
import pause from '../Assets/pause.svg'
import rew from '../Assets/rew.svg'
import fwd from '../Assets/fwd.svg'
import rec from '../Assets/rec.svg'

class ControlPanel extends React.Component {

    ButtonListener = (action) => {
        this.props.onStateChange( action );
    }

    render(){
        return(
            <div id="ControlPanel">
          
              <Button title="operate" action='operate' asset={operate} onButtonPress={ this.ButtonListener } />
              <Button title="eject" action='eject' asset={eject} onButtonPress={ this.ButtonListener }/>
              <Button title="stop" action='stop' asset={stop} onButtonPress={ this.ButtonListener }/>
              <Button title="play" action='play' asset={play} onButtonPress={ this.ButtonListener }/>
              <Button title="pause" action='pause' asset={pause} onButtonPress={ this.ButtonListener }/>
              <Button title="rewind" action='rewind' asset={rew} onButtonPress={ this.ButtonListener }/>
              <Button title="forward" action='fast_forward' asset={fwd} onButtonPress={ this.ButtonListener }/>
              <Button title="record" action='record' asset={rec} color='#DA6560' onButtonPress={ this.ButtonListener }/>
      
            </div>
          );
    }
   
}

export default ControlPanel; 


// WEBPACK FOOTER //
// ./src/ControlPanel/ControlPanel.js